module.exports = __webpack_public_path__ + "static/media/stars-768.b0687d7e.jpg";